import { Card, Row, Form } from 'react-bootstrap'
import { convertDateWithoutTime } from '../../../../helpers/constants'
import { cardStyle, labelDetailStyle } from './constants'

export const StyledDetailField = ({
  label,
  value,
  col = 3,
  children,
  address
}) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {address ? (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        ) : children ? (
          children
        ) : (
          value
        )}
      </div>
    </Form.Group>
  )
}

const GeneralInfo = ({ detail }) => {
  return (
    <Card style={cardStyle}>
      <Row>
        <StyledDetailField label="#so" value={detail?.so} col={6} />
        <StyledDetailField label="customer" value={detail?.customer} col={6} />
        <StyledDetailField label="branch" value={detail?.branch} col={6} />
        <StyledDetailField
          label="source warehouse"
          value={detail?.src}
          col={6}
        />
        <StyledDetailField
          label="delivery address"
          value={detail?.delivery_address ?? '-'}
          col={12}
          address={true}
        />
        <StyledDetailField
          label="delivery date"
          value={
            detail?.delivery_date
              ? convertDateWithoutTime(detail?.delivery_date)
              : '-'
          }
          col={3}
        />
        <StyledDetailField
          label="#Outbound"
          value={detail?.outbound === null ? '-' : detail?.outbound}
          col={3}
        />
      </Row>
    </Card>
  )
}

export default GeneralInfo
